<template>
<section class="item-details-section">
    <div>
        <span class="text-semibold">Name: </span>
        <span>{{ reimbursementType.name }}</span>
    </div>

    <div>
        <span class="text-semibold">Allow Multiple Per Company: </span>
        <span>{{ reimbursementType.allow_multiple_per_company ? 'Yes' : 'No' }}</span>
    </div>
</section>
</template>

<script>
export default {
    props: ['reimbursementType', ],
}
</script>
